/**
 * 사업자등록번호 포맷팅 (000-00-00000)
 * @param {string} value - 입력값
 * @returns {string} 포맷팅된 사업자등록번호
 */
export const formatBusinessNumber = (value) => {
  const numbers = value.replace(/\D/g, '');
  const limitedNumbers = numbers.slice(0, 10);
  
  if (limitedNumbers.length <= 3) {
    return limitedNumbers;
  } else if (limitedNumbers.length <= 5) {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
  } else {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 5)}-${limitedNumbers.slice(5)}`;
  }
};

/**
 * 사업장관리번호 포맷팅 (000-00-00000-0)
 * @param {string} value - 입력값
 * @returns {string} 포맷팅된 사업장관리번호
 */
export const formatBusinessManagementNumber = (value) => {
  const numbers = value.replace(/\D/g, '');
  const limitedNumbers = numbers.slice(0, 11);
  
  if (limitedNumbers.length <= 3) {
    return limitedNumbers;
  } else if (limitedNumbers.length <= 5) {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
  } else if (limitedNumbers.length <= 10) {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 5)}-${limitedNumbers.slice(5)}`;
  } else {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 5)}-${limitedNumbers.slice(5, 10)}-${limitedNumbers.slice(10)}`;
  }
};

/**
 * 세션 시간 포맷팅 (분:초)
 * @param {number} timeLeft - 남은 시간 (밀리초)
 * @returns {string} 포맷팅된 시간 문자열
 */
export const formatSessionTime = (timeLeft) => {
  if (!timeLeft || isNaN(timeLeft) || timeLeft <= 0) return '';
  
  const minutes = Math.floor(timeLeft / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
  if (isNaN(minutes) || isNaN(seconds)) return '';
  
  if (minutes > 0) {
    return `${minutes}분 ${seconds}초`;
  } else {
    return `${seconds}초`;
  }
};

/**
 * 날짜 포맷팅 (YYYY-MM-DD)
 * @param {Date|string} date - 날짜
 * @returns {string} 포맷팅된 날짜 문자열
 */
export const formatDate = (date) => {
  if (!date) return '-';
  
  try {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString('ko-KR');
  } catch (error) {
    return '-';
  }
};

/**
 * 사용자 레벨 표시명 변환
 * @param {string} level - 사용자 레벨
 * @returns {string} 표시용 레벨명
 */
export const getLevelDisplayName = (level) => {
  return level === 'admin' || level === '관리자' ? '관리자' : '일반사용자';
};

/**
 * 사용자 상태 표시명 변환
 * @param {string} status - 사용자 상태
 * @returns {string} 표시용 상태명
 */
export const getStatusDisplayName = (status) => {
  return status === 'normal' ? '정상' : '비활성';
};

/**
 * 전화번호 포맷팅 (000-0000-0000)
 * @param {string} value - 입력값
 * @returns {string} 포맷팅된 전화번호
 */
export const formatPhoneNumber = (value) => {
  const numbers = value.replace(/\D/g, '');
  const limitedNumbers = numbers.slice(0, 11);
  
  if (limitedNumbers.length <= 3) {
    return limitedNumbers;
  } else if (limitedNumbers.length <= 7) {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
  } else {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 7)}-${limitedNumbers.slice(7)}`;
  }
};

/**
 * 금액 포맷팅 (천단위 콤마)
 * @param {number} value - 금액
 * @returns {string} 포맷팅된 금액 문자열
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  return value.toLocaleString('ko-KR');
};